<template>
  <div>
    <el-table
      :data="contentList"
    >
      <el-table-column
        prop="__type"
        label="内容类型">
      </el-table-column>
      <el-table-column
        prop="__language"
        label="语言类型">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button 
            type="primary" 
            circle 
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
          ></el-button>
          <el-button 
            type="danger" 
            circle 
            icon="el-icon-delete"
            @click="handleRemove(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <content-detail :content="content"></content-detail>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import ContentDetail from '../detail';

export default {
  name: 'ContentList',
  components: {
    ContentDetail
  },
  data() {
    return {
      content: {}
    };
  },
  computed: {
    ...mapGetters('contentSetting', ['contentList'])
  },
  methods: {
    ...mapMutations('contentSetting', ['toggleDetailDialogVisible']),
    ...mapActions('contentSetting', ['list', 'remove']),
    handleUpdate(content) {
      this.toggleDetailDialogVisible(true);
      this.content = content;
    },
    handleRemove(id) {
      this.$confirm('确认删除此内容吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.remove(id).then(() => {
            this.$message.success('删除成功！');
            this.list();
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
</style>
